import { getConfig } from '../config/configuration';
import type { HpDispatchFunction } from './actionTypes';
import { fetchResolver } from './fetchResolver';
import { ErrorMap } from 'interfaces/errorTypes';

interface RenewPolicyActionProps {
  username: string;
  isAgent: boolean;
  paymentPreference: 'monthly' | 'yearly';
  paymentReference?: string;
  transactionReference?: string;
  policyDetailsId: string;
  historyId: number;
}

export interface RenewPolicyData {
  accountName: string;
  accountNumber: string;
  agentId: string;
  agreementGuid: string;
  cardExpiry: string;
  cardHolderName: string;
  creditCardLastFour: string;
  customerId: string;
  defaultPaymentToken: string;
  historyId: number;
  onlyReturnDelta: boolean;
  policyDetailsId: string;
  primaryIONumber: string;
  sortCode: string;
  timestamp: string;
  token: string;
  tokenTransactionCount: number;
  transactionId: string;
}

interface GetRenewPolicyDataProps {
  username: string;
  paymentPreference: 'monthly' | 'yearly';
  paymentReference?: string;
  transactionReference?: string;
  policyDetailsId: string;
  historyId: number;
}

const getRenewPolicyData = ({
  username,
  paymentPreference,
  paymentReference,
  transactionReference,
  policyDetailsId,
  historyId
}: GetRenewPolicyDataProps): RenewPolicyData => {
  if (paymentPreference === 'monthly') {
    return {
      accountName: '',
      accountNumber: '',
      agentId: username,
      agreementGuid: '',
      cardExpiry: '',
      cardHolderName: '',
      creditCardLastFour: '',
      customerId: '',
      defaultPaymentToken: '',
      historyId,
      onlyReturnDelta: false,
      policyDetailsId,
      primaryIONumber: '',
      sortCode: '',
      timestamp: '',
      token: '',
      tokenTransactionCount: 0,
      transactionId: ''
    };
  }

  return {
    accountName: '',
    accountNumber: '',
    agentId: username,
    agreementGuid: '',
    cardExpiry: '',
    cardHolderName: '',
    creditCardLastFour: '',
    customerId: '',
    defaultPaymentToken: '',
    historyId,
    onlyReturnDelta: false,
    policyDetailsId,
    primaryIONumber: transactionReference || '',
    sortCode: '',
    timestamp: '',
    token: '',
    tokenTransactionCount: 0,
    transactionId: paymentReference || ''
  };
};

export function renewPolicyAction({
  username,
  isAgent,
  paymentPreference,
  paymentReference,
  transactionReference,
  policyDetailsId,
  historyId
}: RenewPolicyActionProps) {
  return (dispatch: HpDispatchFunction<ErrorMap | string>): Promise<void> | undefined => {
    dispatch({ type: 'RENEW_POLICY_LOADING' });
    const { websiteEndpoint } = getConfig();
    const url = `${websiteEndpoint}/api/policy/renew`;
    const data = getRenewPolicyData({
      username: isAgent ? username : 'customer',
      paymentPreference,
      paymentReference,
      transactionReference,
      policyDetailsId,
      historyId
    });

    return fetchResolver<any>({
      options: { url, data, method: 'POST', description: `Renew policy` },
      dispatch,
      successAction: () => {
        dispatch({ type: 'RENEW_POLICY_SUCCESS', payload: paymentReference });
      },
      failedAction: () => {
        dispatch({ type: 'RENEW_POLICY_ERROR' });
      }
    });
  };
}
